import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import PipelineData from '../PipelineData';
import AddAllButton from './AddAllButton';
import ProgressBar from '../../ProgressBar';
import SummaryBanner from '../../SummaryBanner';
import ModelTemplateHeader from '../ModelTemplateHeader';
import QuotaWarning from './QuotaWarning';
import { miniDisclaimer } from 'constants/values';

export const ModelHeader = ({
  addDisclaimer,
  basePriceFormatted,
  basePriceLabel,
  closeLocalSearch,
  closeSearch,
  collapsedChart,
  currentSelectedQuantity,
  description,
  id,
  imgUrl,
  inCartLabel,
  inCartQuantity,
  inReviewView,
  isClosed,
  isOverCharLimit,
  menuOpen,
  mini,
  modelTemplatesWorkingStateLoading,
  modelWorkingStateDenormalized,
  openChart,
  quota,
  calculatedRemainingQuota,
  remainingQuotaLabel,
  searchMenuVisibility,
  searchOptions,
  searchView,
  selectedOptions,
  seriesAllocationLoading,
  seriesDetailPageLoaded,
  showInReview,
  showSearch,
  showSubmitted,
  styleStat,
  submitted,
  submittedLabel,
}) => (
  <div className={styles.headerContainer}>
    <ProgressBar
      submitted={submitted}
      quota={quota}
      height="3px"
      emptyColor="#e0e0e5"
    />

    {collapsedChart ? (
      <div className={styles.modelHeaderCollapsed} id="modelHeaderCollapsed">
        <div className={styles.modelBannerCollapsed}>
          <h3>{description}</h3>
          <span className={styles.collapsedSummary}>
            {basePriceLabel}: {basePriceFormatted}
          </span>
        </div>
        <div className={styles.modelSummaryCollapsed}>
          <div className={styles.collapsedQuotaWarningContainer}>
            <QuotaWarning
              currentSelectedQuantity={currentSelectedQuantity}
              inCartQuantity={inCartQuantity}
              calculatedRemainingQuota={calculatedRemainingQuota}
              modelTemplatesWorkingStateLoading={
                modelTemplatesWorkingStateLoading
              }
              seriesAllocationLoading={seriesAllocationLoading}
            />
          </div>
          <div className={styleStat.remaining}>
            <span>{calculatedRemainingQuota}</span>
            <span
              className={
                mini ? styles.collapsedMiniLabel : styles.collapsedLabel
              }
            >
              {remainingQuotaLabel}
            </span>
          </div>
          <div className={styleStat.submitted}>
            <span>{submitted}</span>
            <span
              className={
                mini ? styles.collapsedMiniLabel : styles.collapsedLabel
              }
            >
              {submittedLabel}
            </span>
          </div>
          <div className={styleStat.inCart}>
            <span>{inCartQuantity}</span>
            <span
              className={
                mini ? styles.collapsedMiniLabel : styles.collapsedLabel
              }
            >
              {inCartLabel}
            </span>
          </div>
          <AddAllButton
            modelId={id}
            modelWorkingStateDenormalized={modelWorkingStateDenormalized}
            seriesDetailPageLoaded={seriesDetailPageLoaded}
          />
        </div>
      </div>
    ) : (
      <div className={styles.modelHeader} id="modelHeader">
        <div className={styles.modelBanner}>
          <img className={styles.modelImg} src={imgUrl} alt="model" />
          {addDisclaimer && (
            <div className={styles.disclaimer}>{miniDisclaimer}</div>
          )}
          <div>
            <span className={styleStat.modelTitle}>{description}</span>
            <ul className={styles.modelSummary}>
              <li className={styles.summaryStat}>
                {basePriceLabel}: {basePriceFormatted}
              </li>
            </ul>
          </div>
        </div>
        <div className={styles.summaryWithButton}>
          <div className={styles.quotaWarningContainer}>
            <QuotaWarning
              currentSelectedQuantity={currentSelectedQuantity}
              inCartQuantity={inCartQuantity}
              calculatedRemainingQuota={calculatedRemainingQuota}
              modelTemplatesWorkingStateLoading={
                modelTemplatesWorkingStateLoading
              }
              seriesAllocationLoading={seriesAllocationLoading}
            />
          </div>
          <SummaryBanner
            remaining={calculatedRemainingQuota}
            submitted={submitted}
            inCart={inCartQuantity}
          />
          <AddAllButton
            modelId={id}
            modelWorkingStateDenormalized={modelWorkingStateDenormalized}
            seriesDetailPageLoaded={seriesDetailPageLoaded}
          />
        </div>
      </div>
    )}

    {collapsedChart && <PipelineData modelId={id} openChart={openChart} />}
    {collapsedChart && (
      <ModelTemplateHeader
        modelId={id}
        showSearch={showSearch}
        closeSearch={closeSearch}
        closeLocalSearch={closeLocalSearch}
        searchView={searchView}
        searchOptions={searchOptions}
        selectedOptions={selectedOptions}
        inReviewView={inReviewView}
        menuOpen={menuOpen}
        searchMenuVisibility={searchMenuVisibility}
        isClosed={isClosed}
        showInReview={showInReview}
        showSubmitted={showSubmitted}
      />
    )}
  </div>
);

export default enhance(ModelHeader);
